import { UnavailabilityError } from 'expo-modules-core';

export default function AdTriggerView() {
  throw new UnavailabilityError('expo-ads-facebook', 'AdTriggerView');
}
